import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.grid = {
      display: 'grid',
      position: 'relative',
      gridGap: 0,
      gridTemplateColumns: ['1fr', '1fr 1fr'],
    };

    this.media = {
      gridArea: 'media',
      position: 'relative',
      width: '100%',
      height: '100%',
      overflow: 'hidden',
    };

    this.content = {
      gridArea: 'content',
      display: 'flex',
      position: 'relative',
      width: '100%',
      height: '100%',
    };
  })()
);
